import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapComponentLastBoundsSelector = (state: AppState) => state.frontendState.mapComponent.lastBounds;
export const useMapComponentLastBoundsSelector = () => useSelector(mapComponentLastBoundsSelector);

const mapComponentCenterSelector = (state: AppState) => state.frontendState.mapComponent.center;
export const useMapComponentCenterSelector = () => useSelector(mapComponentCenterSelector);

export const mapComponentZoomSelector = (state: AppState) => state.frontendState.mapComponent.zoom;
export const useMapComponentZoomSelector = () => useSelector(mapComponentZoomSelector);

const mapComponentZoomToBoundsSelector = (state: AppState) => state.frontendState.mapComponent.zoomToBounds;
export const useMapComponentZoomToBoundsSelector = () => useSelector(mapComponentZoomToBoundsSelector);

const mapComponentZoomToBoundsPreferredZoomSelector = (state: AppState) => state.frontendState.mapComponent.zoomToBoundsPreferredZoom;
export const useMapComponentZoomToBoundsPreferredZoomSelector = () => useSelector(mapComponentZoomToBoundsPreferredZoomSelector);

const mapComponentAuthoringCenterSelector = (state: AppState) => state.frontendState.mapComponent.authoringCenter;
export const useMapComponentAuthoringCenterSelector = () => useSelector(mapComponentAuthoringCenterSelector);

const mapComponentAuthoringZoomSelector = (state: AppState) => state.frontendState.mapComponent.authoringZoom;
export const useMapComponentAuthoringZoomSelector = () => useSelector(mapComponentAuthoringZoomSelector);

const mapComponentAuthoringOpsSelector = (state: AppState) => state.frontendState.mapComponent.authoringOps;
export const useMapComponentAuthoringOpsSelector = () => useSelector(mapComponentAuthoringOpsSelector);

const mapComponentMapOptionsCurrentSelector = (state: AppState) => state.frontendState.mapComponent.mapOptions.current;
export const useMapComponentMapOptionsCurrentSelector = () => useSelector(mapComponentMapOptionsCurrentSelector);
